module.exports = __webpack_public_path__ + "img/rain-1.7a472a35.jpg";